import type { VariantType } from "../NotificationSettingsTab";
import type { Dispatch, FC, SetStateAction } from "react";

import { Stack } from "@mui/material";
import CustomDropdown from "../../../CustomDropdown";

import { useTranslation } from "react-i18next";
import { dropdownItems } from "../../../../constants/notifications";

interface SettingsTabZboziCaseProps {
  zboziSelectedVariant?: VariantType;
  zboziSetSelectedVariant?: Dispatch<SetStateAction<VariantType>>;
}

export const SettingsTabZboziCase: FC<SettingsTabZboziCaseProps> = ({
  zboziSelectedVariant,
  zboziSetSelectedVariant,
}) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction='column'
      sx={{
        pt: 1,
        gap: 1.5,
        py: 2,
      }}
    >
      <CustomDropdown
        width='100%'
        value={zboziSelectedVariant}
        label={t("campaign.notifications.settings.displayRules.choseVariant")}
        items={dropdownItems.map(item => ({
          title: t(
            `campaign.notifications.settings.displayRules.zbozi.${item.title}`,
          ),
          value: item.value,
        }))}
        onChange={event => {
          if (zboziSetSelectedVariant) {
            zboziSetSelectedVariant(event.target.value as VariantType);
          }
        }}
      />
    </Stack>
  );
};
